import { esc } from '../ui/modal';
import { t } from '../ui/lang';
function formatBytes(n) {
    if (n < 1024)
        return `${n} B`;
    if (n < 1024 * 1024)
        return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
/** "Code" clicker-settings tab — upload / set-current / deploy code bundles. */
export async function renderCodeTab(panel) {
    panel.innerHTML = `
        <details class="settings-section cc-howto">
            <summary class="settings-section__title cc-howto__summary">${t('clickertab.howto')}</summary>
            <ol class="cc-howto__steps">
                <li>${t('clickertab.code_howto_1')}</li>
                <li>${t('clickertab.code_howto_2')}</li>
                <li>${t('clickertab.code_howto_3')}</li>
                <li>${t('clickertab.code_howto_4')}</li>
            </ol>
            <p class="settings-hint">
                ${t('clickertab.code_howto_farms_intro')}
            </p>
            <ul class="cc-howto__legend">
                <li><span class="status-dot status-dot--green"></span> / <span class="status-dot status-dot--red"></span> — ${t('clickertab.code_howto_legend_dot')}</li>
                <li>${t('clickertab.code_howto_legend_running')}</li>
                <li>${t('clickertab.code_howto_legend_status')}</li>
            </ul>
            <p class="settings-hint">
                ${t('clickertab.code_howto_baked_note')}
            </p>
        </details>
        <div class="settings-section">
            <h3 class="settings-section__title">${t('clickertab.upload_version')}</h3>
            <p class="settings-hint">
                ${t('clickertab.code_upload_hint')}
            </p>
            <form class="settings-code-form" novalidate>
                <div class="modal__field">
                    <label>${t('clickertab.version')}</label>
                    <input class="settings-input cc-version" type="text" autocomplete="off" placeholder="${t('clickertab.version_placeholder')}" required />
                </div>
                <div class="modal__field">
                    <label>${t('clickertab.note')} <span class="settings-hint" style="display:inline">${t('clickertab.optional')}</span></label>
                    <input class="settings-input cc-note" type="text" autocomplete="off" placeholder="${t('clickertab.note_placeholder')}" />
                </div>
                <div class="modal__field">
                    <label>${t('clickertab.bundle')}</label>
                    <input class="settings-input cc-file" type="file" accept=".gz,.tgz,application/gzip" required />
                </div>
                <button type="submit" class="modal__submit" style="margin-top:12px">${t('clickertab.upload')}</button>
            </form>
            <div class="settings-error modal__error cc-add-error" style="display:none"></div>
        </div>
        <div class="settings-section">
            <h3 class="settings-section__title">${t('clickertab.versions')}</h3>
            <div class="cc-list">${t('common.loading')}</div>
        </div>
        <div class="settings-section">
            <h3 class="settings-section__title">${t('clickertab.farms')}</h3>
            <div class="cc-farms">${t('common.loading')}</div>
        </div>
    `;
    const form = panel.querySelector('.settings-code-form');
    const versionInput = panel.querySelector('.cc-version');
    const noteInput = panel.querySelector('.cc-note');
    const fileInput = panel.querySelector('.cc-file');
    const addError = panel.querySelector('.cc-add-error');
    const listEl = panel.querySelector('.cc-list');
    const farmsEl = panel.querySelector('.cc-farms');
    const showAddErr = (msg) => { addError.textContent = msg; addError.style.display = 'block'; };
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        addError.style.display = 'none';
        const version = versionInput.value.trim();
        const note = noteInput.value.trim();
        const file = fileInput.files?.[0];
        if (!/^[A-Za-z0-9._-]{1,64}$/.test(version)) {
            showAddErr(t('clickertab.err_version_format'));
            return;
        }
        if (!file) {
            showAddErr(t('clickertab.err_choose_bundle'));
            return;
        }
        const btn = form.querySelector('.modal__submit');
        btn.disabled = true;
        try {
            const buf = await file.arrayBuffer();
            const r = await fetch(`/api/clicker/code?version=${encodeURIComponent(version)}&note=${encodeURIComponent(note)}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/gzip' },
                body: buf,
            });
            if (!r.ok) {
                showAddErr((await r.json()).error ?? t('clickertab.upload_failed'));
                return;
            }
            form.reset();
            void load();
        }
        catch {
            showAddErr(t('clickertab.network_error'));
        }
        finally {
            btn.disabled = false;
        }
    });
    async function load() {
        let data;
        try {
            const r = await fetch('/api/clicker/code');
            if (!r.ok) {
                listEl.innerHTML = `<p class="settings-hint">${t('clickertab.failed_to_load_dot')}</p>`;
                farmsEl.innerHTML = '';
                return;
            }
            data = await r.json();
        }
        catch {
            listEl.innerHTML = `<p class="settings-hint">${t('clickertab.network_error_dot')}</p>`;
            return;
        }
        renderVersions(data.versions);
        renderFarms(data.farms, data.versions.find((v) => v.is_current)?.version ?? '');
    }
    function renderVersions(versions) {
        if (versions.length === 0) {
            listEl.innerHTML = `<p class="settings-hint">${t('clickertab.no_versions')}</p>`;
            return;
        }
        const rows = versions.map((v) => `
            <tr data-version="${esc(v.version)}">
                <td>${esc(v.version)}${v.is_current ? ` <span class="cc-badge cc-badge--current">${t('clickertab.badge_current')}</span>` : ''}</td>
                <td>${esc(v.note)}</td>
                <td title="${esc(v.sha256)}">${formatBytes(v.size)}</td>
                <td>${esc(new Date(v.created_at).toLocaleString())}</td>
                <td class="cc-actions">
                    <button type="button" class="modal__submit cc-deploy" data-version="${esc(v.version)}">${t('clickertab.deploy_to_all')}</button>
                    ${v.is_current ? '' : `<button type="button" class="modal__submit cc-current" data-version="${esc(v.version)}">${t('clickertab.set_current')}</button>`}
                    <button type="button" class="modal__submit modal__submit--danger cc-del" data-version="${esc(v.version)}">${t('common.delete')}</button>
                </td>
            </tr>
        `).join('');
        listEl.innerHTML = `
            <table class="access-matrix">
                <thead><tr><th>${t('clickertab.version')}</th><th>${t('clickertab.note')}</th><th>${t('clickertab.size')}</th><th>${t('clickertab.uploaded')}</th><th></th></tr></thead>
                <tbody>${rows}</tbody>
            </table>
            <div class="settings-error modal__error cc-deploy-result" style="display:none"></div>
        `;
        wireVersionActions();
    }
    function renderFarms(farms, currentVersion) {
        if (farms.length === 0) {
            farmsEl.innerHTML = `<p class="settings-hint">${t('clickertab.no_farms')}</p>`;
            return;
        }
        const rows = farms.map((f) => {
            const running = f.version || '—';
            let status;
            if (!f.version)
                status = `<span class="settings-hint">${t('clickertab.badge_unknown')}</span>`;
            else if (currentVersion && f.version === currentVersion)
                status = `<span class="cc-badge cc-badge--ok">${t('clickertab.badge_up_to_date')}</span>`;
            else
                status = `<span class="cc-badge cc-badge--drift">${t('clickertab.badge_differs')}</span>`;
            const dot = f.online ? 'status-dot--green' : 'status-dot--red';
            // Reset only makes sense when the farm runs a hot-pushed overlay — a
            // baked / unknown farm has nothing custom to clear.
            const canReset = !!f.version && f.version !== 'baked';
            return `
                <tr>
                    <td><span class="status-dot ${dot}"></span> ${esc(f.name)}</td>
                    <td>${esc(running)}</td>
                    <td>${status}</td>
                    <td class="cc-actions">
                        ${canReset ? `<button type="button" class="modal__submit modal__submit--danger cc-reset" data-farm-id="${f.id}" data-farm-name="${esc(f.name)}">${t('clickertab.reset_to_baked')}</button>` : ''}
                    </td>
                </tr>
            `;
        }).join('');
        farmsEl.innerHTML = `
            <table class="access-matrix">
                <thead><tr><th>${t('common.farm')}</th><th>${t('clickertab.running')}</th><th>${t('common.status')}</th><th></th></tr></thead>
                <tbody>${rows}</tbody>
            </table>
            <div class="settings-error modal__error cc-reset-result" style="display:none"></div>
        `;
        wireFarmActions();
    }
    function wireFarmActions() {
        const resultEl = farmsEl.querySelector('.cc-reset-result');
        farmsEl.querySelectorAll('.cc-reset').forEach((btn) => {
            let armed = false;
            const orig = btn.textContent ?? t('clickertab.reset_to_baked');
            btn.addEventListener('click', async () => {
                if (!armed) {
                    armed = true;
                    btn.textContent = t('clickertab.confirm_reset');
                    setTimeout(() => { armed = false; btn.textContent = orig; }, 4000);
                    return;
                }
                resultEl.style.display = 'none';
                btn.disabled = true;
                btn.textContent = t('clickertab.resetting');
                try {
                    const farmId = Number(btn.dataset['farmId']);
                    const name = btn.dataset['farmName'] ?? '';
                    const r = await fetch('/api/clicker/code/reset', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ farmIds: [farmId] }),
                    });
                    const body = await r.json();
                    if (!r.ok) {
                        resultEl.textContent = body.error ?? t('clickertab.reset_failed');
                        resultEl.style.display = 'block';
                        return;
                    }
                    const res = (body.results ?? [])[0];
                    resultEl.textContent = res && res.ok
                        ? t('clickertab.reset_farm_ok', { name })
                        : `${t('clickertab.reset_farm_failed', { name })}${res?.error ? ` — ${res.error}` : ''}`;
                    resultEl.style.display = 'block';
                    void load();
                }
                catch {
                    resultEl.textContent = t('clickertab.network_error');
                    resultEl.style.display = 'block';
                }
                finally {
                    btn.disabled = false;
                    armed = false;
                    btn.textContent = orig;
                }
            });
        });
    }
    function wireVersionActions() {
        const resultEl = listEl.querySelector('.cc-deploy-result');
        listEl.querySelectorAll('.cc-deploy').forEach((btn) => {
            btn.addEventListener('click', async () => {
                resultEl.style.display = 'none';
                btn.disabled = true;
                const orig = btn.textContent;
                btn.textContent = t('clickertab.deploying');
                try {
                    const version = btn.dataset['version'];
                    const r = await fetch(`/api/clicker/code/${encodeURIComponent(version)}/deploy`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({}),
                    });
                    const body = await r.json();
                    if (!r.ok) {
                        resultEl.textContent = body.error ?? t('clickertab.deploy_failed');
                        resultEl.style.display = 'block';
                        return;
                    }
                    const results = body.results ?? [];
                    const ok = results.filter((x) => x.ok).length;
                    const failed = results.length - ok;
                    const errs = [...new Set(results.filter((x) => !x.ok && x.error).map((x) => x.error))].join('; ');
                    resultEl.textContent = `${t('clickertab.deployed_summary', { version, ok, failed })}${errs ? ` — ${errs}` : ''}`;
                    resultEl.style.display = 'block';
                    void load();
                }
                catch {
                    resultEl.textContent = t('clickertab.network_error');
                    resultEl.style.display = 'block';
                }
                finally {
                    btn.disabled = false;
                    btn.textContent = orig;
                }
            });
        });
        listEl.querySelectorAll('.cc-current').forEach((btn) => {
            btn.addEventListener('click', async () => {
                btn.disabled = true;
                try {
                    const version = btn.dataset['version'];
                    const r = await fetch(`/api/clicker/code/${encodeURIComponent(version)}/current`, { method: 'POST' });
                    if (r.ok)
                        void load();
                    else
                        btn.disabled = false;
                }
                catch {
                    btn.disabled = false;
                }
            });
        });
        listEl.querySelectorAll('.cc-del').forEach((btn) => {
            let armed = false;
            btn.addEventListener('click', async () => {
                if (!armed) {
                    armed = true;
                    btn.textContent = t('common.confirm');
                    setTimeout(() => { armed = false; btn.textContent = t('common.delete'); }, 4000);
                    return;
                }
                btn.disabled = true;
                try {
                    const version = btn.dataset['version'];
                    const r = await fetch(`/api/clicker/code/${encodeURIComponent(version)}`, { method: 'DELETE' });
                    if (r.ok)
                        void load();
                    else {
                        btn.disabled = false;
                        armed = false;
                        btn.textContent = t('common.delete');
                    }
                }
                catch {
                    btn.disabled = false;
                }
            });
        });
    }
    void load();
}
